const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";

export const uploadFile = async (file, onProgress) => {
  const formData = new FormData();
  formData.append("file", file);

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && onProgress) {
        const pct = Math.round((e.loaded / e.total) * 100);
        onProgress(pct);
      }
    };

    xhr.onload = () => {
      if (xhr.status === 200) {
        const data = JSON.parse(xhr.responseText);
        resolve({
          url: data.signedUrl,
          publicId: data.publicId,
          resourceType: data.resourceType,
        });
      } else {
        const err = JSON.parse(xhr.responseText);
        reject(new Error(err?.error || "Error subiendo archivo"));
      }
    };

    xhr.onerror = () => reject(new Error("Error de red"));

    xhr.open("POST", `${BASE_URL}/api/upload`);
    xhr.send(formData);
  });
};